<template>
  <!-- {{ item }} -->
  <div
    class="px-2.5 py-1.5 my-2 rounded-lg border-1 transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white ">
    <div class="relative grid grid-cols-5 tablet:grid-cols-12 laptop:grid-cols-10 gap-1.5 tablet:gap-0.5 laptop:gap-1.5 largeDesktop:gap-2.5 break-words">
      <div class="col-span-3 tablet:col-span-1 hidden">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">ID:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          {{ item.id }}
        </p>
      </div>
      <div class="col-span-3 tablet:col-span-3 laptop:col-span-3 largeDesktop:col-span-4 relative group">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Name:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          {{ $helper.isEmpty(item.first_name) ? '-' : item.first_name }} {{ $helper.isEmpty(item.last_name) ? '-' :
            item.last_name }}
        </p>
      </div>
      <div class="col-span-2 flex items-center justify-end tablet:justify-start tablet:hidden tablet:pl-2.5 mobile:pr-[40px]">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block hidden">Status:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          <span v-if="item.active == '1'"
            class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#65B741] text-[#fff]">Active</span>
          <span v-else class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#EA8A8A] text-[#fff]">Inactive</span>
        </p>
      </div>

      <div class="col-span-5 tablet:col-span-3 laptop:col-span-2 largeDesktop:col-span-3 relative group break-words">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">
          Email:
        </span>

        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal ">
          {{ $helper.isEmpty(item.email) ? '-' : item.email }}
        </p>
      </div>
      <div class="col-span-5 tablet:col-span-2 laptop:col-span-3 largeDesktop:col-span-2">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Phone:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          {{ $helper.isEmpty(item.phone) ? '-' : item.phone }}
        </p>
      </div>
      <div class="col-span-5 tablet:col-span-3 laptop:col-span-3 largeDesktop:col-span-2">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Stripe:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          {{ item.stripe }}
        </p>
      </div>

      <div v-if="getActions().length > 0"
        class="col-span-5 tablet:col-span-1 absolute top-[10px] right-2.5 tablet:static flex items-center justify-end ">
        <div ref="dropdownWrapper">
          <div  class="relative flex">
            <button class="focus:outline-none" @click="toggleDropdown">
              <img src="../../../assets/images/vertical-dot-icon.png" alt="Up Down Arrow" class="w-[25px] h-[25px]">
            </button>
            <ul v-if="isOpen"
              class="absolute top-[25px] right-0 z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-roboto py-[5px] overflow-hidden">
              <li v-for="option in getActions()" :key="option" @click="select(option)"
                class="px-2 py-[5px] mx-[10px] my-[5px] rounded-md hover:bg-customYellow-100 hover:text-white cursor-pointer text-left">
                {{ option }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-span-5 tablet:col-span-3 laptop:col-span-3 largeDesktop:col-span-2">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Last Login:</span>
        <p v-if="item.last_login_at != 'N/A'" class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
                {{ $helper.formatDateTimestamp(item.last_login_at, 'MM/DD/YYYY - hh:mm A') }}
        </p>
        <p v-else class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
             {{ item.last_login_at }}
        </p>
      </div>

      <div class="col-span-5 tablet:col-span-3">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Affiliate Type</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal">
          {{ $helper.isEmpty(item.affiliate_type_name) ? '-' : item.affiliate_type_name }}
        </p>
      </div>
      <div class="col-span-5 tablet:col-span-1 mobile:hidden tablet:block">
        <span class="text-[#999999] font-roboto text-[14px] tablet:text-[13px] laptop:text-base inline-block">Status:</span>
        <p class="m-0 font-roboto text-[13px] tablet:text-[12px] laptop:text-sm font-normal min-w-[110px]">
          <span v-if="item.active == '1'"
            class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#65B741] text-[#fff]">Active</span>
          <span v-else class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#EA8A8A] text-[#fff]">Inactive</span>
        </p>
      </div>
      

    </div>
  </div>
</template>
<script>

export default {
  props: ["item"],
  components: {
  },
  mounted() {

    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  data() {
    return {
      isOpen: false,
      user: JSON.parse(localStorage.getItem("user")) ?? null
    };
  },
  methods: {

    getActions() {
      let res = []
      if (this.user?.user?.user_id == this.item.parent_id) {
        res.push("Edit")
        res.push("Resend Invite")
        if (this.item.active != '1') {
          res.push("Active")
        }
        else {
          res.push("Inactive")
        }
      }
      let affiliateType = this.user.user.affiliate.affiliate_type
      if (affiliateType == 'master') {

        if (this.item.affiliate_type_slug == 'normal') {
          res.push("Mark as Employee")
        }
        else if (this.item.affiliate_type_slug == 'employee') {
          res.push("Mark as Standard")
        }
      }
      return res
    },


    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(value) {
      // this.selected = value;
      this.isOpen = false;
      this.$emit('update', this.item, value); // emit change if needed
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },
  }
};
</script>